/**
 * Pure date/number helpers for the analytics feature.
 *
 * All counter dates are UTC day strings (`YYYY-MM-DD`). We deliberately format
 * via `toISOString().slice(0,10)` and never `new Date(str).toLocaleDateString()`,
 * which would shift the day in non-UTC browsers.
 */

/** A UTC `YYYY-MM-DD` string for a Date. */
export function utcDayString(d: Date): string {
  return d.toISOString().slice(0, 10);
}

/** Inclusive range covering the last `n` days ending today (UTC). */
export function lastNDays(n: number): { from: string; to: string } {
  const to = new Date();
  const from = new Date();
  from.setUTCDate(from.getUTCDate() - (n - 1));
  return { from: utcDayString(from), to: utcDayString(to) };
}

/** `YYYY-MM-DD` → `DD/MM` for compact axis labels. */
export function formatShortDate(dateStr: string): string {
  const [, m, d] = dateStr.split("-");
  return `${d}/${m}`;
}

/** 1234567 → "1.2M", 12345 → "12K". */
export function formatCompactNumber(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K`;
  return String(value);
}
